import {BasicCriteria} from '../../framework/parameters/BasicCriteria';

export class EntityModificationCriteria extends BasicCriteria {
entityTypes: number[];
fromDate: number | null;
fromPack: string;
fromRevision: number | null;
fromUser: string;
range: string;
rangeValue: string;
refCode: string;
visionCode: string;
}

